<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding10" :style="{ 'min-height': `${this.screenHeight - 160}px` }">
        <el-row>
            <el-col :span="16" class="align-left">
                <h3>手术安全核查</h3>
            </el-col>
            <el-button style="float: right;margin-right: 10px !important;" type="primary" size="mini" @click="ReloadListData()" title="刷新当前页面">刷新</el-button>
        </el-row>
        <el-row>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">科别：{{ surgeryInfo.dic_section }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">姓名：{{ surgeryInfo.patient_name }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">性别：{{ surgeryInfo.sex || `--` }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">年龄：{{ surgeryInfo.age || `--` }}</label>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">{{ T(`Saftycheck.visit_no`) }}：{{ surgeryInfo.visit_no || `--` }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">手术日期：{{ $moment(surgeryInfo.plan_time).format('YYYY/MM/DD') || `--` }}</label>
            </el-col>
            <el-col :span="12" class="align-left">
                <label style="line-height: 35px">手术名称：{{ surgeryInfo.surgeries || `--` }}</label>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-col :lg="isdesktop == true ? 24 : 8" :md="24" v-show="ShowCard(1) == true">
                <div>
                    <el-card :body-style="{ padding: '5px', height: isdesktop == true ? `${this.screenHeight - 160}px` : `${this.screenHeight - 270}px` }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">麻前检查</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-checkbox v-if="isShowSelectAll" v-model="isSelectedAll.p1" @change="selectedAll('p1')">全选</el-checkbox>
                            </el-col>
                        </el-row>
                        <div class="card-content" :style="{ 'overflow-y': 'auto', height: isdesktop == true ? `${this.screenHeight - 190}px` : `${this.screenHeight - 300}px` }">
                            <cus-form
                                ref="form-p1"
                                :key="`${this.surgeryId}_p1`"
                                :columns="sys_check_list"
                                :data="data_p.data_p1"
                                @imgclick="imgclick"
                                @imgdelete="imgdelete"
                                @extrabutton-click="ExtraButtonClick"
                                @confirm="saveP1"
                            >
                            </cus-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <!-- unCheckedList.indexOf(1) === -1 -->
            <el-col :lg="isdesktop == true ? 24 : 8" :md="24" v-show="ShowCard(2) == true">
                <div>
                    <el-card :body-style="{ padding: '5px', height: isdesktop == true ? `${this.screenHeight - 160}px` : `${this.screenHeight - 270}px` }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">术前检查</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-checkbox v-if="isShowSelectAll" v-model="isSelectedAll.p2" @change="selectedAll('p2')">全选</el-checkbox>
                            </el-col>
                        </el-row>
                        <div class="card-content" :style="{ 'overflow-y': 'auto', height: isdesktop == true ? `${this.screenHeight - 190}px` : `${this.screenHeight - 300}px` }">
                            <cus-form
                                ref="form-p2"
                                :key="`${this.surgeryId}_p2`"
                                :columns="sys_check_list2"
                                :data="data_p.data_p2"
                                @imgclick="imgclick"
                                @imgdelete="imgdelete"
                                @extrabutton-click="ExtraButtonClick"
                                @confirm="saveP1"
                            ></cus-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :lg="isdesktop == true ? 24 : 8" :md="24" v-show="ShowCard(3) == true">
                <div>
                    <el-card :body-style="{ padding: '5px', height: isdesktop == true ? `${this.screenHeight - 160}px` : `${this.screenHeight - 270}px` }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">出室检查</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-checkbox v-if="isShowSelectAll" v-model="isSelectedAll.p3" @change="selectedAll('p3')">全选</el-checkbox>
                            </el-col>
                        </el-row>
                        <div class="card-content" :style="{ 'overflow-y': 'auto', height: isdesktop == true ? `${this.screenHeight - 190}px` : `${this.screenHeight - 300}px` }">
                            <cus-form
                                ref="form-p3"
                                :key="`${this.surgeryId}_p3`"
                                :columns="sys_check_list3"
                                :data="data_p.data_p3"
                                @imgclick="imgclick"
                                @imgdelete="imgdelete"
                                @extrabutton-click="ExtraButtonClick"
                                @confirm="saveP1"
                            ></cus-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <el-dialog :title="`${title}签名`" :close-on-click-modal="false" :visible.sync="showDialogVisible" width="60%" @close="handleClose">
            <iframe ref="qrcode" :src="signUrl" allow="microphone;camera;canvas" v-show="showDialogVisible" class="docframe width-p100" seamless :style="{ height: '500px' }"></iframe>
        </el-dialog>
        <div v-if="msgDialogVisible" class="menu_box" :style="{ left: menuLeft + 'px', top: menuTop + 'px' }">
            <div class="menu">
                <div class="menu_item item_text" @click="deletemsg">删除</div>
                <div class="menu_item item_text" @click="msgDialogVisible = false">取消</div>
            </div>
        </div>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SaftyCheck`,
    props: {},
    data() {
        window.addEventListener(
            `message`,
            event => {
                if (event.data.action == `ok`) {
                    this.showDialogVisible = false
                    this.CaSignBody(event.data)
                } else {
                    // this.showDialogVisible = false
                }
            },
            false
        )
        return {
            title: `安全核查`,
            token: this.$route.query.token,
            catoken: this.$route.query.catoken,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            msgDialogVisible: false,
            menuLeft: 0,
            menuTop: 0,
            msgsaftycheck: 0,
            msgporp: ``,
            isShowSelectAll: false,
            permissions: [],
            isSelectedAll: {
                p1: undefined,
                p2: undefined,
                p3: undefined
            },
            isdesktop: false,
            useCa: this.$root.useCa,
            SaftyCheckUseCa: this.$root.SaftyCheckUseCa,
            caSignUrl: this.$root.CaSignUrl,
            caImagePath: this.$root.CaImagePath,
            saftyCheckReSign: this.$root.SaftyCheckReSign,
            query_enum_safty_check: this.$route.query.enum_safty_check,
            showDialogVisible: false,
            signUrl: ``,
            processlist: [],
            name: {
                doctor: undefined,
                anesthesiaDoctor: undefined,
                nurse: undefined
            },
            currentList: [],
            data_p: {
                data_p1: {
                    safecheck_p1_mqjc: ``,
                    defaultsafecheck: `1`
                },
                data_p1_def: {
                    safecheck_p1_mqjc: ``,
                    defaultsafecheck: `1`
                },
                data_p2: {
                    safecheck_p2_rsja: ``,
                    safecheck_p2_shfx: ``,
                    safecheck_p2_mzys: ``,
                    safecheck_p2_shhs: ``,
                    defaultsafecheck: `2`
                },
                data_p2_def: {
                    safecheck_p2_rsja: ``,
                    safecheck_p2_shfx: ``,
                    safecheck_p2_mzys: ``,
                    safecheck_p2_shhs: ``,
                    defaultsafecheck: `2`
                },
                data_p3: { safecheck_p3_csjc: ``, defaultsafecheck: `3` },
                data_p3_def: { safecheck_p3_csjc: ``, defaultsafecheck: `3` }
            },
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: {},
            checked: false,
            unCheckedList: [],
            saftyCheckRefreshTime: this.$root.SaftyCheckRefreshTime,
            selectAll: `security_check:selectAll` // 全选权限
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        if (this.catoken) {
            sessionStorage.setItem(`caToken`, this.catoken)
        }
        this.isShowHidden()
        console.log(`this.$route.query`)
        console.log(this.$route.query)
        // this.$store.dispatch(`sysuser/ADD_WORKERS`)

        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
    },
    mounted() {
        let that = this
        clearInterval(this.refreshListData)
        this.$store.dispatch(`sysuser/ADD_WORKERS`).then(() => {
            console.log(this.worker)
            this.init()
            if (this.query_enum_safty_check != undefined && this.query_enum_safty_check != null) {
                this.isdesktop = true
            }
            if (that.saftyCheckRefreshTime && that.saftyCheckRefreshTime > 0) {
                that.refreshListData = setInterval(() => {
                    that.reload()
                }, that.saftyCheckRefreshTime * 1000)
            }
        })
    },
    beforeDestroy() {
        clearInterval(this.refreshListData)
    },
    computed: {
        ...mapGetters([`sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `currentUser`, `screenHeight`, `sys_enums`, `active_ward`]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        sys_check_list() {
            let me = this
            let editCheckTime = this.permissions && this.permissions.findIndex(item => item.permission === `security_check:edit_checkTime`) > -1
            let list = [
                {
                    type: `p`,
                    prop: `safty_check_start_time`,
                    label: { content: `开始时间`, position: `left` },
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `p`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    readonly: true,
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `datetime`,
                    prop: `safty_check_start_time`,
                    label: { content: `开始时间`, position: `left` },
                    colspan: this.isdesktop == true ? 12 : 16,
                    area: [2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `datetime`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: this.isdesktop == true ? 12 : 16,
                    area: [2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p1_mqjc`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `患者身份确认` },
                        { value: `3`, label: `手术方式确认` },
                        { value: `2`, label: `手术部位与标识确认` },
                        { value: `13`, label: `手术知情同意` },
                        { value: `4`, label: `麻醉知情同意` },
                        { value: `5`, label: `麻醉方式确认` },
                        { value: `6`, label: `麻醉设备安全检查完成` },
                        { value: `8`, label: `静脉通道建立完成` },
                        { value: `7`, label: `血氧监测建立` },
                        // ,{value:'9',label:"计划自体输血"}
                        { value: `10`, label: `假体` },
                        { value: `11`, label: `体内植入物` },
                        { value: `12`, label: `影像学资料` }
                    ],
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_wanzhengxing`,
                    label: { content: `皮肤是否完整`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_shuyezhunbei`,
                    label: { content: `术野皮肤准备正确`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_gms`,
                    label: { content: `患者是否有过敏史`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_pishijieguo`,
                    label: { content: `抗菌药物皮试结果`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_sqbx`,
                    label: { content: `术前备血`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p1_zitixue`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `计划自体输血` },
                        { value: `2`, label: `计划异体输血` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_sqkss`,
                    label: { content: `术前使用抗生素`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p1_qidao`,
                    label: { content: `气道障碍或呼吸功能障碍`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` },
                        { value: 3, label: `设备提供支持` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                },
                {
                    type: `string`,
                    prop: `safecheck_p1_qt`,
                    label: { content: `其他`, position: `top` },
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 1)
                    }
                }
            ]
            if (!this.isCaSign()) {
                list.push({
                    type: `remoteselect`,
                    prop: `safecheck_p1_doctor_name`,
                    label: { content: `手术医生签名`, position: `top` },
                    colspan: 8,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            // alert(this.isWorkerByDuty)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                },
                {
                    type: `remoteselect`,
                    prop: `safecheck_p1_anesthesia_name`,
                    label: { content: `麻醉医生签名`, position: `top` },
                    colspan: 8,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    config: { popperAppendToBody: true },
                    validate: [{ required: !me.surgeryInfo.is_local_anes, message: `必填项目`, trigger: `blur` }],
                    area: [1, 2]
                },
                {
                    type: `remoteselect`,
                    prop: `safecheck_p1_nurse_name`,
                    label: { content: `巡回护士签名`, position: `top` },
                    colspan: 8,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true },
                    area: [1, 2]
                })
            } else {
                list.push({
                    type: `img`,
                    prop: `SurgeonCode1`,
                    label: { content: `手术医生签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    default: ``,
                    area: [1, 2]
                }, {
                    type: `img`,
                    prop: `AnesthesiaCode1`,
                    label: { content: `麻醉医生签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    area: [1, 2]
                }, {
                    type: `img`,
                    prop: `NurseCode1`,
                    label: { content: `巡回护士签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    area: [1, 2]
                })
            }
            list.push({
                type: `buttongroup`,
                prop: `oper`,
                label: { content: ` `, position: `top` },
                options: (that, { row }) => {
                    if (row.origion.p1_checked) {
                        return [
                            {
                                label: `保存`,
                                type: `primary`,
                                emit: `checkedThrough`,
                                permission: `default`
                            }
                        ]
                    }
                    return [
                        {
                            label: `核对通过`,
                            type: `primary`,
                            emit: `checkedThrough`,
                            permission: `default`
                        },
                        {
                            label: `核对不通过`,
                            type: `default`,
                            emit: `checkedReject`,
                            permission: `default`
                        }
                    ]
                },
                colspan: 24,
                config: {
                    align: `start`
                },
                area: [1, 2]
            })
            return _.filter(list, d => {
                return editCheckTime ? d.area.indexOf(2) > -1 : d.area.indexOf(1) > -1
            })
        },
        sys_check_list2() {
            let editCheckTime = this.permissions && this.permissions.findIndex(item => item.permission === `security_check:edit_checkTime`) > -1
            let me = this
            let list = [
                {
                    type: `p`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `datetime`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 16,
                    area: [2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_rsja`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `4`, label: `患者身份确认` },
                        { value: `2`, label: `手术方式确认` },
                        { value: `1`, label: `手术部位与标识确认` },
                        { value: `3`, label: `手术体位确认` },
                        { value: `5`, label: `手术、麻醉风险预警` }

                    ],
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 2)
                    }
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_shfx`,
                    label: { content: `手术医生陈述：`, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `预计手术时间` },
                        { value: `2`, label: `预计失血量` },
                        { value: `3`, label: `手术关注点` },
                        { value: `4`, label: `其他` }
                    ],
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 2)
                    }
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_mzys`,
                    label: { content: `麻醉医生陈述：`, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `麻醉关注点` },
                        { value: `2`, label: `应对方案` },
                        { value: `3`, label: `其他` }
                    ],
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 2)
                    }
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p2_shhs`,
                    label: { content: `手术护士陈述：`, position: `top` },
                    readonly: false,
                    options: [
                        { value: `1`, label: `物品灭菌合格` },
                        { value: `3`, label: `仪器设备完好` },
                        { value: `4`, label: `术前术中特殊用药情况` },
                        { value: `2`, label: `应对方案` },
                        { value: `5`, label: `其他` }
                    ],
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 2)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p2_gms`,
                    label: { content: `术前0.5-2小时内给与预防性抗生素`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 2)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p2_wanzhengxing`,
                    label: { content: `需要相关影像资料`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 2)
                    }
                },
                // ,{
                //   type: "radio",
                //   prop: "safecheck_p2_qidao",
                //   label: {content:'气道障碍或呼吸功能障碍',position:'top'},
                //   readonly:false,
                //   options:[{value:1,label:"有"}
                //   ,{value:2,label:"无"}
                //   ,{value:3,label:'设备提供支持'}],
                //   colspan:24,
                // }
                {
                    type: `string`,
                    prop: `safecheck_p2_qt`,
                    label: { content: `其他`, position: `top` },
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 2)
                    }
                }]
            if (!this.isCaSign()) {
                list.push(
                    {
                        type: `remoteselect`,
                        prop: `safecheck_p2_doctor_name`,
                        label: { content: `手术医生签名`, position: `top` },
                        colspan: 8,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        config: { popperAppendToBody: true },
                        area: [1, 2]
                    },
                    {
                        type: `remoteselect`,
                        prop: `safecheck_p2_anesthesia_name`,
                        label: { content: `麻醉医生签名`, position: `top` },
                        colspan: 8,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: !me.surgeryInfo.is_local_anes, message: `必填项目`, trigger: `blur` }],
                        config: { popperAppendToBody: true },
                        area: [1, 2]
                    },
                    {
                        type: `remoteselect`,
                        prop: `safecheck_p2_nurse_name`,
                        label: { content: `巡回护士签名`, position: `top` },
                        colspan: 8,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        config: { popperAppendToBody: true },
                        area: [1, 2]
                    })
            } else {
                list.push({
                    type: `img`,
                    prop: `SurgeonCode2`,
                    label: { content: `手术医生签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    default: ``,
                    area: [1, 2]
                }, {
                    type: `img`,
                    prop: `AnesthesiaCode2`,
                    label: { content: `麻醉医生签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    area: [1, 2]
                }, {
                    type: `img`,
                    prop: `NurseCode2`,
                    label: { content: `巡回护士签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    area: [1, 2]
                })
            }
            list.push(
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: { content: ` `, position: `top` },
                    options: (that, { row }) => {
                        if (row.origion.p2_checked) {
                            return [
                                {
                                    label: `保存`,
                                    type: `primary`,
                                    emit: `checkedThrough`,
                                    permission: `default`
                                }
                            ]
                        }
                        return [
                            {
                                label: `核对通过`,
                                type: `primary`,
                                emit: `checkedThrough`,
                                permission: `default`
                            },
                            {
                                label: `核对不通过`,
                                type: `default`,
                                emit: `checkedReject`,
                                permission: `default`
                            }
                        ]
                    },
                    colspan: 24,
                    config: {
                        align: `start`
                    },
                    area: [1, 2]
                }
            )
            return _.filter(list, d => {
                return editCheckTime ? d.area.indexOf(2) > -1 : d.area.indexOf(1) > -1
            })
        },
        sys_check_list3() {
            let editCheckTime = this.permissions && this.permissions.findIndex(item => item.permission === `security_check:edit_checkTime`) > -1
            let me = this
            let list = [
                {
                    type: `p`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 12,
                    area: [1]
                },
                {
                    type: `datetime`,
                    prop: `safty_check_occur_time`,
                    label: { content: `确认时间`, position: `left` },
                    colspan: 16,
                    area: [2]
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p3_csjc`,
                    label: { content: ` `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `11`, label: `患者身份确认` },
                        { value: `1`, label: `记录实施手术名称 ` },
                        { value: `12`, label: `实际手术方式确认` },
                        { value: `13`, label: `手术用药、输血的核查` },
                        { value: `14`, label: `体位要求` },
                        { value: `10`, label: `x-ray和签名` }

                    ],
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_qdshwp`,
                    label: { content: `清点手术用物`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `数量正确` },
                        { value: 2, label: `数量不正确` }
                    ],
                    colspan: 8,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_ssbbqr`,
                    label: { content: `手术标本确认`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `有` },
                        { value: 2, label: `无` }
                    ],
                    colspan: 8,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_wanzhengxing`,
                    label: { content: `皮肤是否完整`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 8,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_qgztchuzhi`,
                    label: { content: `手术切除器官、肢体处置`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_sbjx`,
                    label: { content: `仪器设备需要检修`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `是` },
                        { value: 2, label: `否` }
                    ],
                    colspan: 12,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `checkboxgroup`,
                    prop: `safecheck_p3_gzgl`,
                    label: { content: `各种管路 `, position: `top` },
                    readonly: false,
                    options: [
                        { value: `16`, label: `静脉通路` },
                        { value: `6`, label: `中心静脉通路` },
                        { value: `9`, label: `动脉通路` },
                        { value: `8`, label: `气管插管` },
                        { value: `4`, label: `伤口引流管` },
                        { value: `5`, label: `胃管` },
                        { value: `7`, label: `尿管` },
                        { value: `15`, label: `其他` }

                    ],
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `string`,
                    // field_style: `font-weight:bold;text-align:left;text-align-last:left;color:red;position:relative;top:-100px;`,
                    label: { content: ` `, position: `top` },
                    prop: `safecheck_p3_gzgl_qt_text`,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `radio`,
                    prop: `safecheck_p3_brqx`,
                    label: { content: `病人去向`, position: `top` },
                    readonly: false,
                    options: [
                        { value: 1, label: `PACU(复苏室)` },
                        { value: 2, label: `回病房` },
                        { value: 3, label: `ICU病房` },
                        { value: 4, label: `急诊` },
                        { value: 5, label: `离院` }
                    ],
                    colspan: 16,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                },
                {
                    type: `string`,
                    prop: `safecheck_p3_qt`,
                    label: { content: `其他`, position: `top` },
                    colspan: 24,
                    area: [1, 2],
                    change: (that, { row, index }) => {
                        row = me.checkSaftyCheckReSign(row, 3)
                    }
                }]
            if (!this.isCaSign()) {
                list.push(
                    {
                        type: `remoteselect`,
                        prop: `safecheck_p3_doctor_name`,
                        label: { content: `手术医生签名`, position: `top` },
                        colspan: 8,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        config: { popperAppendToBody: true },
                        area: [1, 2]
                    },
                    {
                        type: `remoteselect`,
                        prop: `safecheck_p3_anesthesia_name`,
                        label: { content: `麻醉医生签名`, position: `top` },
                        colspan: 8,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: !me.surgeryInfo.is_local_anes, message: `必填项目`, trigger: `blur` }],
                        config: { popperAppendToBody: true },
                        area: [1, 2]
                    },
                    {
                        type: `remoteselect`,
                        prop: `safecheck_p3_nurse_name`,
                        label: { content: `巡回护士签名`, position: `top` },
                        colspan: 8,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        config: { popperAppendToBody: true },
                        area: [1, 2]
                    })
            } else {
                list.push({
                    type: `img`,
                    prop: `SurgeonCode3`,
                    label: { content: `手术医生签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    default: ``,
                    area: [1, 2]
                }, {
                    type: `img`,
                    prop: `AnesthesiaCode3`,
                    label: { content: `麻醉医生签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    area: [1, 2]
                }, {
                    type: `img`,
                    prop: `NurseCode3`,
                    label: { content: `巡回护士签名`, position: `top` },
                    colspan: 8,
                    height: 40,
                    area: [1, 2]
                })
            }
            list.push(
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: { content: ` `, position: `top` },
                    options: (that, { row }) => {
                        if (row.origion.p3_checked) {
                            return [
                                {
                                    label: `保存`,
                                    type: `primary`,
                                    emit: `checkedThrough`,
                                    permission: `default`
                                }
                            ]
                        }
                        return [
                            {
                                label: `核对通过`,
                                type: `primary`,
                                emit: `checkedThrough`,
                                permission: `default`
                            },
                            {
                                label: `核对不通过`,
                                type: `default`,
                                emit: `checkedReject`,
                                permission: `default`
                            }
                        ]
                    },
                    colspan: 24,
                    config: {
                        align: `start`
                    },
                    area: [1, 2]
                })

            return _.filter(list, d => {
                return editCheckTime ? d.area.indexOf(2) > -1 : d.area.indexOf(1) > -1
            })
        }
    },
    methods: {
        ReloadListData() {
            this.init()
        },
        handleClose() {
            // 处理关闭事件
            this.signUrl = ``
            console.log(`Dialog closed`)
        },
        checkSaftyCheckReSign(row, num) {
            let that = this
            return new Promise((resolve, reject) => {
                if (that.saftyCheckReSign && that.saftyCheckReSign.trim() == `1` &&
                        ((row[`SurgeonCode${num}`] && row[`SurgeonCode${num}`].trim() != ``) ||
                                (row[`AnesthesiaCode${num}`] && row[`AnesthesiaCode${num}`].trim() != ``) != null ||
                                (row[`NurseCode${num}`] && row[`NurseCode${num}`].trim() != ``) != null)
                ) {
                    that.$alert(`用户数据修改需要重新签名`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    }).then(data => {
                        row[`SurgeonCode${num}`] = undefined
                        row[`AnesthesiaCode${num}`] = undefined
                        row[`NurseCode${num}`] = undefined
                        row[`safecheck_p${num}_doctor_name`] = undefined
                        row[`safecheck_p${num}_anesthesia_name`] = undefined
                        row[`safecheck_p${num}_nurse_name`] = undefined

                        that.data_p[`data_p${num}`][`SurgeonCode${num}`] = undefined
                        that.data_p[`data_p${num}`][`AnesthesiaCode${num}`] = undefined
                        that.data_p[`data_p${num}`][`NurseCode${num}`] = undefined
                        that.data_p[`data_p${num}`][`safecheck_p${num}_doctor_name`] = undefined
                        that.data_p[`data_p${num}`][`safecheck_p${num}_anesthesia_name`] = undefined
                        that.data_p[`data_p${num}`][`safecheck_p${num}_nurse_name`] = undefined

                        resolve(row)
                    }).catch(e => {
                        console.log(e)
                        resolve(row)
                    })
                }
                resolve(row)
            })
        },
        isShowHidden() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(permissions => {
                this.permissions = permissions
                this.isShowSelectAll = _.find(permissions, { no: `security_check:selectAll` }) != undefined
            }).catch(e => {
                console.log(e)
            })
        },
        ShowCard(check) {
            console.log(this.unCheckedList)
            if (this.query_enum_safty_check != undefined && this.query_enum_safty_check != null) {
                if (check == this.query_enum_safty_check) {
                    return true
                }
                return false
            } else {
                let index = check - 1
                if (this.unCheckedList.indexOf(index) === -1) {
                    return true
                }
                return false
            }
        },
        isCaSign() {
            if (this.useCa == `1` && this.SaftyCheckUseCa == `1`) {
                return true
            }
            return false
        },
        imgclick(e) {
            this.DoCaSign(e)
        },
        imgdelete(e) {
            let that = this
            let saftycheck = e.formdata.origion.enum_safty_check || e.formdata.origion.defaultsafecheck
            let info = that.data_p[`data_p${saftycheck}`][e.column.prop]
            if (info && info.trim() != ``) {
                that.menuLeft = e && e.event && e.event.clientX || 0
                that.menuTop = e && e.event && e.event.clientY || 0
                that.msgsaftycheck = saftycheck
                that.msgporp = e.column.prop
                that.msgDialogVisible = true
            }
        },
        deletemsg() {
            let that = this
            if (that.data_p[`data_p${that.msgsaftycheck}`] && that.data_p[`data_p${that.msgsaftycheck}`][that.msgporp]) {
                that.data_p[`data_p${that.msgsaftycheck}`][that.msgporp] = undefined
                if (that.msgporp.indexOf(`Surgeon`) > -1) {
                    that.data_p[`data_p${that.msgsaftycheck}`][`safecheck_p${that.msgsaftycheck}_doctor_name`] = undefined
                } else if (that.msgporp.indexOf(`Anesthesia`) > -1) {
                    that.data_p[`data_p${that.msgsaftycheck}`][`safecheck_p${that.msgsaftycheck}_anesthesia_name`] = undefined
                } else if (that.msgporp.indexOf(`Nurse`) > -1) {
                    that.data_p[`data_p${that.msgsaftycheck}`][`safecheck_p${that.msgsaftycheck}_nurse_name`] = undefined
                }
                that.SaftyCheckUseCa = 0
                that.SaftyCheckUseCa = 1
            }
            that.msgDialogVisible = false
        },
        CaSignBody(data) {
            let that = this
            let bizdata = data.data
            let req = that.myaxios.get(`/api/AcisSystem/Authorization/GetAcUserByUserCode?username=${bizdata.username}`)
            req.then(user => {
                let bizs = bizdata.biz_id.split(`_`)
                if (bizs.length >= 1) {
                    let enumsaftycheck = bizs[1]
                    let proname = bizs[2]
                    console.log(user)
                    // safecheck_p1_doctor_name
                    that.data_p[`data_p${enumsaftycheck}`][proname] = `${this.caImagePath}/${bizdata.username}.png`
                    if (proname.indexOf(`Surgeon`) > -1) {
                        that.data_p[`data_p${enumsaftycheck}`][`safecheck_p${enumsaftycheck}_doctor_name`] = { label: user.dic_worker_name, value: user.dic_worker_id }
                    } else if (proname.indexOf(`Anesthesia`) > -1) {
                        that.data_p[`data_p${enumsaftycheck}`][`safecheck_p${enumsaftycheck}_anesthesia_name`] = { label: user.dic_worker_name, value: user.dic_worker_id }
                    } else if (proname.indexOf(`Nurse`) > -1) {
                        that.data_p[`data_p${enumsaftycheck}`][`safecheck_p${enumsaftycheck}_nurse_name`] = { label: user.dic_worker_name, value: user.dic_worker_id }
                    }

                    console.log(`2222222222222`)
                    console.log(that.data_p)
                    console.log(`3333333333333`)
                    // 这里更改一下这个参数，用来触发一下create,不然图片会不刷新
                    that.SaftyCheckUseCa = 0
                    that.SaftyCheckUseCa = 1
                }
            })
        },
        DoCaSign(e) {
            console.log(e.formdata)
            let datas = this.getSaftyCheckItems(e.formdata)
            let r = JSON.stringify(datas)
            console.log(r)
            console.log(e.formdata.origion)
            let url = `${this.caSignUrl}?app_key=${this.$root.appKey}&ca_token=`
            let caToken = sessionStorage.getItem(`caToken`)
            if (caToken) url = `${url}${caToken}`
            var random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            let rcode = ``
            for (var i = 0; i < 8; i++) {
                // 设置随机数范围,这设置为0 ~ 36
                var index = Math.floor(Math.random() * 9)
                // 字符串拼接 将每次随机的字符 进行拼接
                rcode += random[index]
            }
            this.myaxios.post(url, {
                user_agent: `chrome`,
                timestamp: new Date().getTime(),
                data: {
                    biz_id: this.surgeryId + `_` + (e.formdata.origion.enum_safty_check || e.formdata.origion.defaultsafecheck) + `_` + e.column.prop + `_` + rcode,
                    raw_data: r
                }
            }).then((signUrl) => {
                console.log(signUrl)
                this.signUrl = signUrl + `&type=${e.column.prop}`
                this.showDialogVisible = true
            })
        },
        init() {
            if (!this.surgeryId) return
            let that = this
            // 获取当前手术信息
            let req = this.myaxios.get(`/api/Operation/Home/Get?id=${this.surgeryId}`)
            let req1 = this.myaxios.get(`/api/Intraoperative/SaftyCheck/Records?surgeryInfoId=${this.surgeryId}`)
            let req2 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/OccuredEvents?surgeryInfoId=${this.surgeryId}&recordType=1`)
            // 获取局麻事件列表
            let req3 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/PartAnesEvents?surgeryInfoId=${this.surgeryId}&recordType=1`)
            this.myaxios.all(req, req1, req2, req3).then(([data, data1, data2, data3]) => {
                let events = data2.length == 0 ? data3 : data2
                // 患者基本信息
                this.surgeryInfo = data
                let passData = _.filter(data1, { is_pass: true })
                // 重置信息
                that.data_p[`data_p1`] = _.cloneDeep(that.data_p[`data_p1_def`])
                that.data_p[`data_p2`] = _.cloneDeep(that.data_p[`data_p2_def`])
                that.data_p[`data_p3`] = _.cloneDeep(that.data_p[`data_p3_def`])
                _.reduce(
                    data1,
                    function(items, item, key) {
                        // 麻前检查时间获取进手术间时间
                        let startTime = item && item.start_time || _.filter(events, { event_name: `进手术间` })[0] && _.filter(events, { event_name: `进手术间` })[0].occur_time
                        let occurTime = item && item.check_date
                        let r = _.reduce(
                            item.safty_check_items,
                            function(result, value, key) {
                                result[value.check_name] = value.check_value
                                if (_.endsWith(value.check_name, `doctor_name`)) {
                                    result[value.check_name] = that.getWokerName(value.check_value, 1)
                                }
                                if (_.endsWith(value.check_name, `anesthesia_name`)) {
                                    result[value.check_name] = that.getWokerName(value.check_value, 2)
                                }
                                if (_.endsWith(value.check_name, `nurse_name`)) {
                                    result[value.check_name] = that.getWokerName(value.check_value, 3)
                                }

                                result[`p${item.enum_safty_check}_checked`] = item.is_pass
                                result[`enum_safty_check`] = item.enum_safty_check
                                result[`id`] = item.id
                                result[`safty_check_start_time`] = (startTime && that.$moment(startTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                                result[`safty_check_occur_time`] = (occurTime && that.$moment(occurTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                                return result
                            },
                            {}
                        )
                        that.data_p[`data_p${item.enum_safty_check}`] = Object.assign({}, that.data_p[`data_p${item.enum_safty_check}_def`], r)
                        // 初始化赋值
                        if (!that.data_p[`data_p${item.enum_safty_check}`][`safecheck_p${item.enum_safty_check}_doctor_name`]) { that.data_p[`data_p${item.enum_safty_check}`][`safecheck_p${item.enum_safty_check}_doctor_name`] = { value: item.surgeon, label: item.surgeon_name } }
                        if (!that.data_p[`data_p${item.enum_safty_check}`][`safecheck_p${item.enum_safty_check}_anesthesia_name`]) that.data_p[`data_p${item.enum_safty_check}`][`safecheck_p${item.enum_safty_check}_anesthesia_name`] = { value: item.anesthesiologist, label: item.anesthesiologist_name }
                        if (!that.data_p[`data_p${item.enum_safty_check}`][`safecheck_p${item.enum_safty_check}_nurse_name`]) that.data_p[`data_p${item.enum_safty_check}`][`safecheck_p${item.enum_safty_check}_nurse_name`] = { value: item.circuit_nurse, label: item.circuit_nurse_name }
                    },
                    {}
                )

                if (!that.data_p[`data_p1`][`safty_check_start_time`]) {
                    let ptime = _.filter(events, { event_name: `进手术间` })[0] && _.filter(events, { event_name: `进手术间` })[0].occur_time || new Date()
                    that.data_p[`data_p1`][`safty_check_start_time`] = that.$moment(ptime).format(`YYYY-MM-DD HH:mm`)
                }
                // if (!that.data_p[`data_p1`][`safty_check_occur_time`]) {
                //     that.data_p[`data_p1`][`safty_check_occur_time`] = that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                // }
                // if (!that.data_p[`data_p2`][`safty_check_occur_time`]) {
                //     that.data_p[`data_p2`][`safty_check_occur_time`] = that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                // }
                // if (!that.data_p[`data_p3`][`safty_check_occur_time`]) {
                //     that.data_p[`data_p3`][`safty_check_occur_time`] = that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                // }
                // 获取当前核查阶段
                let stage = _.map(passData, d => {
                    return d.enum_safty_check
                })
                let r = _.filter(this.sys_enums.SaftyCheckStage, d => {
                    return stage.indexOf(d.value) === -1
                })
                if (r.length !== 0) {
                    this.currentList = {
                        id: r[0].value,
                        label: r[0].label
                    }
                } else {
                    this.currentList = {
                        id: this.sys_enums.SaftyCheckStage[stage.length - 1].value,
                        label: this.sys_enums.SaftyCheckStage[stage.length - 1].value.label
                    }
                }
                // 未核查记录
                this.unCheckedList = _.map(r, d => {
                    return d.value
                })

                if (!this.isCaSign() && r.length !== 0) {
                    // ACIS-23527 已记录保存手术医生、巡回护士、麻醉医生情况下，各节点安全核查自动提取带出
                    if (!that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_doctor_name`]) {
                        that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_doctor_name`] = data.plan_surgeon_doctor
                    }
                    if (!that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_anesthesia_name`]) {
                        that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_anesthesia_name`] = data.plan_anes_doctor
                    }

                    if (!that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_nurse_name`] && data.plan_circuit_nurse && data.plan_circuit_nurse.length > 0) {
                        that.data_p[`data_p${that.currentList.id}`][`safecheck_p${that.currentList.id}_nurse_name`] = data.plan_circuit_nurse[0]
                    }
                }
            })
        },
        ExtraButtonClick(target) {
            this[target.emit](target)
        },
        selectedAll(key) {
            let that = this
            if (this.isSelectedAll[key]) {
                that.data_p[`data_${key}`][`safecheck_${key}_mqjc`] = `1,2,3,4,5,6,7,8,9,10,11,12,13`
                that.data_p[`data_${key}`][`safecheck_${key}_rsja`] = `1,2,3,4,5`
                that.data_p[`data_${key}`][`safecheck_${key}_shfx`] = `1,2,3,4`
                that.data_p[`data_${key}`][`safecheck_${key}_shhs`] = `1,2,3,4,5`
                that.data_p[`data_${key}`][`safecheck_${key}_mzys`] = `1,2,3`
                that.data_p[`data_${key}`][`safecheck_${key}_csjc`] = `1,2,3,4,5,6,7,8,9,10,11,12,13,14`
                that.data_p[`data_${key}`][`safecheck_${key}_gzgl`] = `4,5,6,7,8,9,15,16`
            } else {
                that.data_p[`data_${key}`][`safecheck_${key}_mqjc`] = ``
                that.data_p[`data_${key}`][`safecheck_${key}_rsja`] = ``
                that.data_p[`data_${key}`][`safecheck_${key}_shfx`] = ``
                that.data_p[`data_${key}`][`safecheck_${key}_shhs`] = ``
                that.data_p[`data_${key}`][`safecheck_${key}_csjc`] = ``
                that.data_p[`data_${key}`][`safecheck_${key}_mzys`] = ``
                that.data_p[`data_${key}`][`safecheck_${key}_gzgl`] = ``
            }
        },
        saveData(formdata, ispass) {
            let that = this
            let lists = this.getSaftyCheckItems(formdata)
            let saftycheck = formdata.origion.enum_safty_check || formdata.origion.defaultsafecheck
            let data = {
                id: formdata.origion.id || 0,
                biz_surgery_info_id: this.surgeryId,
                enum_safty_check: saftycheck,
                is_pass: ispass,
                check_date: formdata.safty_check_occur_time,
                start_time: formdata.safty_check_start_time,
                safty_check_items: lists
            }

            if (this.isCaSign() == true) {
                if (ispass) {
                    let surgeon = that.data_p[`data_p${saftycheck}`][`safecheck_p${saftycheck}_doctor_name`]
                    let anesthesiologist = that.data_p[`data_p${saftycheck}`][`safecheck_p${saftycheck}_anesthesia_name`]
                    let circuitnurse = that.data_p[`data_p${saftycheck}`][`safecheck_p${saftycheck}_nurse_name`]

                    if (surgeon) {
                        data.surgeon = surgeon.value
                        data.surgeon_name = surgeon.label
                    }
                    if (anesthesiologist) {
                        data.anesthesiologist = anesthesiologist.value
                        data.anesthesiologist_name = anesthesiologist.label
                    }
                    if (circuitnurse) {
                        data.circuit_nurse = circuitnurse.value
                        data.circuit_nurse_name = circuitnurse.label
                    }
                } else {
                    data.surgeon = -1
                    data.surgeon_name = `核查未通过`
                    data.anesthesiologist = -1
                    data.anesthesiologist_name = `核查未通过`
                    data.circuit_nurse = -1
                    data.circuit_nurse_name = `核查未通过`
                }
            } else {
                let surgenDoctor
                if (formdata[`safecheck_p${saftycheck}_doctor_name`]) {
                    surgenDoctor = _.filter(this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [], d => {
                        return d.value == formdata[`safecheck_p${saftycheck}_doctor_name`].value
                    })
                }
                let anesthesiaDoctor
                if (formdata[`safecheck_p${saftycheck}_anesthesia_name`]) {
                    anesthesiaDoctor = _.filter(this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || [], d => {
                        return d.value == formdata[`safecheck_p${saftycheck}_anesthesia_name`].value
                    })
                }
                let anesthesiaNurse
                if (formdata[`safecheck_p${saftycheck}_nurse_name`]) {
                    anesthesiaNurse = _.filter(this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || [], d => {
                        return d.value == formdata[`safecheck_p${saftycheck}_nurse_name`].value
                    })
                }
                data.surgeon = (surgenDoctor && surgenDoctor[0] && surgenDoctor[0].value) || undefined
                data.anesthesiologist = (anesthesiaDoctor && anesthesiaDoctor[0] && anesthesiaDoctor[0].value) || undefined
                data.circuit_nurse = (anesthesiaNurse && anesthesiaNurse[0] && anesthesiaNurse[0].value) || undefined
                data.surgeon_name = surgenDoctor && surgenDoctor[0] && surgenDoctor[0].label
                data.anesthesiologist_name = anesthesiaDoctor && anesthesiaDoctor[0] && anesthesiaDoctor[0].label
                data.circuit_nurse_name = anesthesiaNurse && anesthesiaNurse[0] && anesthesiaNurse[0].label
            }
            // 判断空条件
            if (data.surgeon === undefined || data.surgeon_name === undefined) {
                this.$message.warning(`手术医生确认不能为空`)
                return
            }

            // 局麻手术 有些情况会没有麻醉医生，不用判断麻醉医生必填
            if (!that.surgeryInfo.is_local_anes && (data.anesthesiologist === undefined || data.anesthesiologist_name === undefined)) {
                this.$message.warning(`麻醉医生确认不能为空`)
                return
            }
            if (data.circuit_nurse === undefined || data.circuit_nurse_name === undefined) {
                this.$message.warning(`巡回护士确认不能为空`)
                return
            }

            let sussmessage = ``
            saftycheck = parseInt(saftycheck)
            switch (saftycheck) {
            case 1:
                sussmessage = `麻前检查`
                break
            case 2:
                sussmessage = `术前检查`
                break
            case 3:
                sussmessage = `出室检查`
                break
            default:
                sussmessage = `麻前检查`
                break
            }
            let req = that.myaxios.post(`/api/Intraoperative/SaftyCheck/Records`, data)
            req.then(data => {
                this.init()
                if (ispass) {
                    this.$message.success(sussmessage + `保存成功`)
                } else {
                    this.$message.warning(sussmessage + `核对不通过`)
                }
                this.sendMessage()
            }).catch(e => {
                console.log(e)
            })
        },
        sendMessage() {
            if (this.isdesktop) {
                let r = typeof winformMsg
                if (r != `undefined`) {
                    var cefJson = {
                        data: {},
                        action: `closeWindow`
                    }
                    winformMsg.acceptMessage(cefJson)
                }
            }
        },
        getSaftyCheckItems(row) {
            let that = this
            let lists = _.reduce(
                row,
                function(result, value, key) {
                    let type = typeof value
                    if (value !== undefined && value !== null && key !== `origion` && !_.endsWith(key, `doctor_name`) && !_.endsWith(key, `anesthesia_name`) && !_.endsWith(key, `nurse_name`)) {
                        result.push({
                            id: 0,
                            biz_safty_check_id: that.currentList.id,
                            check_name: key,
                            check_value: type === `object` ? value.toString() : value
                        })
                    }
                    if (value !== undefined && value !== null && (_.endsWith(key, `doctor_name`) || _.endsWith(key, `anesthesia_name`) || _.endsWith(key, `nurse_name`))) {
                        result.push({
                            id: 0,
                            biz_safty_check_id: that.currentList.id,
                            check_name: key,
                            check_value: type === `object` ? value.value.toString() : value
                        })
                    }
                    return result
                },
                []
            )
            return lists
        },
        checkedThrough(row) {
            let { formdata } = row
            this.saveData(formdata, true)
        },

        checkedReject(row) {
            let { formdata } = row
            let that = this
            let saftycheck = formdata.origion.enum_safty_check || formdata.origion.defaultsafecheck

            if (saftycheck > 0 && that.SaftyCheckUseCa == 1) {
                formdata[`SurgeonCode${saftycheck}`] = undefined
                formdata[`AnesthesiaCode${saftycheck}`] = undefined
                formdata[`NurseCode${saftycheck}`] = undefined
                formdata.origion[`SurgeonCode${saftycheck}`] = undefined
                formdata.origion[`AnesthesiaCode${saftycheck}`] = undefined
                formdata.origion[`NurseCode${saftycheck}`] = undefined
                that.data_p[`data_p${saftycheck}`][`safecheck_p${saftycheck}_doctor_name`] = undefined
                that.data_p[`data_p${saftycheck}`][`safecheck_p${saftycheck}_anesthesia_name`] = undefined
                that.data_p[`data_p${saftycheck}`][`safecheck_p${saftycheck}_nurse_name`] = undefined
                that.SaftyCheckUseCa = 0
                that.SaftyCheckUseCa = 1
            }
            this.saveData(formdata, false)
        },
        saveP1(row) {
            console.log(row)
        },
        getWokerName(id, type) {
            let works = []
            if (type == 1) {
                works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
            } else if (type == 2) {
                works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
            } else {
                works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
            }
            return _.find(works, x => x.value == id)
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.init()
        }
    }
}
</script>
<style scoped>
#div1 {
    position: relative;
}
#div2 {
    position: relative;
    left: 20px;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
h3 {
    margin: 0;
}

.card-content /deep/ .safecheck_p3_gzgl .el-form-item__content div label:nth-last-child(1) {
    display: block;
}

.card-content /deep/ .safecheck_p3_gzgl .el-form-item__label {
    width: 100%;
    display: flex;
}

.card-content /deep/ .el-form-item__content {
    line-height: 35px !important;
}

.card-content /deep/ .safecheck_p3_gzgl_qt_text {
    width: 120px;
    position: absolute;
}

/* position: relative;
    right: -220px;
    top: -52px; */

.card-content /deep/ .safecheck_p3_gzgl_qt_text .el-form-item__content {
    margin-left: 10px !important;
    position: relative;
    top: -46px;
    left: 80px;
}
</style>
<style  lang="less">
.handover-nurse .el-timeline-item__node {
    cursor: pointer;
    z-index: 2;
    &:hover {
        width: 20px;
        height: 20px;
        left: -6px;
        top: -6px;
        background: #409eff;
    }
}
// .safecheck_p1_gms  {
//   label.el-form-item__label{
//     color:red !important;
//   }
// }
.menu_box {
    position: fixed;
    z-index: 1004;
    background-color: #fff;
    // border-radius: 5px;
    .menu {
        width: 100px;
        text-align: left;
        // padding: 5px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .menu_item {
            height: 24px;
            line-height: 22px;
            // margin-top: 5px;
        }
        .item_text {
            color: #171a1d;
            cursor: pointer;
            padding: 4px 20px;
            // border-radius: 3px;
            transition: all 0.2s ease-in;
        }
        .item_text:hover {
            background-color: #e9eaec;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/SaftyCheck/Index.vue